import { RootState } from "store/store";
import TenantFilters from "./TenantFilters";
import { connect } from "react-redux";
import { setEnvironmentFilterStatus } from "store/filters/filters-actions";
import {
    getActiveEnvironmentId,
    getActiveEnvironmentMoniker,
} from "store/environments/environment-selectors";
import { getActiveEnvironmentFilterStatusSelector } from "store/filters/filters-selectors";
import constants from "utils/constants";
import { TenantStatus } from "store/environments/tenants/tenants-types";
import { getEnrollAllowedSortedTenantsSelector } from "store/environments/tenants/tenants-selectors";
import { getTenantsPingInfoSelector } from "store/environments/tenants/tenant-ping/tenant-ping-selectors";

const mapStateToProps = (state: RootState) => {
    const status = getActiveEnvironmentFilterStatusSelector(state);

    return {
        activeStatus:
            status === TenantStatus.Normal ||
            status === TenantStatus.Error ||
            status === TenantStatus.Enroll ||
            status === TenantStatus.Deleting
                ? status
                : constants.defaultIndex,
        activeEnvironmentId: getActiveEnvironmentId(state),
        tenants: getEnrollAllowedSortedTenantsSelector(state),
        tenantsPingInfo: getTenantsPingInfoSelector(
            state,
            getActiveEnvironmentMoniker(state)
        ),
    };
};
const TenantFiltersContainer = connect(mapStateToProps, {
    setEnvironmentFilterStatus,
})(TenantFilters);

export default TenantFiltersContainer;
